import { WebPlugin } from '@capacitor/core';

import type { InitSpeechKitOptions, InputOptions, NuanceSpeechkitPlugin } from './definitions';

export class NuanceSpeechkitWeb
  extends WebPlugin
  implements NuanceSpeechkitPlugin
{
  initSpeechKit(options: InitSpeechKitOptions): Promise<void> {
    console.log(options)
    throw new Error('Method not implemented.');
  }
  start(options:InputOptions): Promise<{ text: string; }> {
    console.log(options)
    throw new Error('Method not implemented.');
  }
  async echo(options: { value: string }): Promise<{ value: string }> {
    console.log('ECHO', options);
    return options;
  }
}
